import { Ref, ref } from 'vue'
import { LocationQueryValue } from 'vue-router'

import { StateField, StateFieldConfig } from '../StateField'

export type NumberStateFieldConfig = StateFieldConfig<NumberStateField> & {
  type: 'number'
  default?: number
  overrideValue?: Ref<number>

  min?: number
  max?: number
  inputStep?: number
  inputAllowManualInput?: boolean
}

export class NumberStateField extends StateField {
  readonly type = 'number'
  default: number = 0
  value: Ref<number>

  min?: number
  max?: number
  inputStep?: number
  inputAllowManualInput?: boolean

  constructor(config: NumberStateFieldConfig) {
    super(config)

    this.default = config.default || 0
    this.value = config.overrideValue || ref(this.default)

    this.min = config.min
    this.max = config.max
    this.inputStep = config.inputStep
    this.inputAllowManualInput = config.inputAllowManualInput
  }

  toRouteValue(): string | undefined {
    if (this.toRouteValueOverride) return this.toRouteValueOverride(this)

    if (this.value.value === this.default) return undefined
    return this.value.value.toString()
  }

  pullRouteQueryValue(value: LocationQueryValue | LocationQueryValue[]): void {
    if (this.pullRouteQueryValueOverride)
      return this.pullRouteQueryValueOverride(this, value)

    this.value.value = Number(value?.toString() || this.default || 0)
    if (isNaN(this.value.value)) this.value.value = this.default || 0
  }

  pullRouteParamValue(value: string | string[]): void {
    if (this.pullRouteParamValueOverride)
      return this.pullRouteParamValueOverride(this, value)

    this.value.value = Number(value?.toString() || this.default || 0)
    if (isNaN(this.value.value)) this.value.value = this.default || 0
  }

  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  async toRequestVariable(variation: number): Promise<any> {
    if (this.toRequestVariableOverride)
      return await this.toRequestVariableOverride(this, variation)

    return this.value.value
  }

  resetValue(): void {
    if (this.resetValueOverride) return this.resetValueOverride(this)
    this.value.value = this.default || 0
  }
}
